var _path, _path2, _ellipse, _ellipse2, _path3, _ellipse3, _ellipse4, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarDefaultState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 80,
    viewBox: "0 0 88 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 44.5C56 51.1274 50.6274 56.5 44 56.5C37.3726 56.5 32 51.1274 32 44.5C32 37.8726 37.3726 32.5 44 32.5C50.6274 32.5 56 37.8726 56 44.5Z",
    fill: "#F5F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.27 18.0153L21.7939 16.5581L15.4355 5.54445L12.9116 7.00163L19.27 18.0153Z",
    fill: "#A3C5DE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 3.50005,
    rx: 3.5,
    ry: 3.50005,
    transform: "matrix(0.866025 -0.5 -0.49998 -0.866037 12.2993 9.94156)",
    fill: "#4C7D9F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5.00007,
    rx: 5,
    ry: 5.00007,
    transform: "matrix(0.866025 -0.5 -0.49998 -0.866037 19.4883 25.3939)",
    fill: "#3F7091"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7031 18.0153L66.1792 16.5581L72.5376 5.54445L75.0615 7.00163L68.7031 18.0153Z",
    fill: "#A3C5DE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 3.50005,
    rx: 3.5,
    ry: 3.50005,
    transform: "matrix(-0.866025 -0.5 0.49998 -0.866037 75.6738 9.94156)",
    fill: "#4C7D9F"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5.00007,
    rx: 5,
    ry: 5.00007,
    transform: "matrix(-0.866025 -0.5 0.49998 -0.866037 68.4849 25.3939)",
    fill: "#3F7091"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9331 47.3469C56.4628 41.6387 62.3301 38.2506 68.0384 39.7802C73.7468 41.3097 77.134 47.1783 75.6044 52.8867C74.1174 58.4361 71.1969 63.4971 67.1365 67.5618C63.0761 71.6265 58.0182 74.5524 52.4702 76.0453C46.9222 77.538 41.0792 77.5451 35.5274 76.0669C29.9754 74.5886 24.9094 71.6761 20.8382 67.622C16.651 63.452 16.6367 56.6772 20.8064 52.4896C24.9764 48.3021 31.7521 48.2875 35.9397 52.4575C37.3515 53.8634 39.1081 54.8736 41.0334 55.3864C42.9587 55.899 44.9854 55.8966 46.9094 55.3789C48.8335 54.8612 50.5879 53.8464 51.9961 52.4368C53.4043 51.0271 54.4174 49.2716 54.9331 47.3469Z",
    fill: "#4C7D9F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4113 12.7763C41.1165 11.2349 46.9909 14.6107 48.5324 20.3159C50.0736 26.0209 46.6986 31.8952 40.9938 33.4368C39.0703 33.9565 37.3172 34.973 35.9105 36.3841C34.5039 37.7952 33.4929 39.5514 32.9792 41.4765C32.4655 43.4016 32.4669 45.428 32.9835 47.3523C33.5003 49.2768 34.5142 51.0317 35.9231 52.4407C40.1019 56.6195 40.1015 63.3948 35.9228 67.5736C31.7439 71.7525 24.9687 71.7522 20.7899 67.5733C16.7274 63.5107 13.8044 58.4516 12.3144 52.9028C10.8246 47.354 10.8198 41.5109 12.3009 35.9598C13.7821 30.4086 16.6969 25.3438 20.753 21.2748C24.8093 17.2058 29.8648 14.2749 35.4113 12.7763Z",
    fill: "#7BA9F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4772 12.7586C41.0268 11.2715 46.8701 11.2699 52.4205 12.754C57.9709 14.2381 63.0338 17.156 67.1007 21.2144C71.1674 25.2728 74.0954 30.3297 75.5911 35.8769C77.0868 41.4241 77.0973 47.2676 75.6219 52.8203C74.1041 58.5315 68.2442 61.9313 62.5329 60.414C56.8213 58.8964 53.4214 53.0357 54.939 47.3241C55.4507 45.3984 55.4463 43.3719 54.9276 41.4481C54.4088 39.5242 53.3933 37.7706 51.9829 36.3632C50.5725 34.9557 48.8167 33.9442 46.8919 33.4295C44.967 32.9148 42.9408 32.915 41.0162 33.4307C35.3079 34.9602 29.4405 31.572 27.911 25.8636C26.3817 20.1554 29.769 14.2882 35.4772 12.7586Z",
    fill: "#FFC300"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9333 47.3469C56.463 41.6387 62.3304 38.2506 68.0386 39.7801C73.747 41.3097 77.1342 47.1783 75.6047 52.8867C73.8138 59.5697 69.9532 65.5143 64.5762 69.8685C59.9835 73.5876 53.2453 72.8797 49.5262 68.2871C45.807 63.6943 46.5159 56.9559 51.1086 53.2367C52.9733 51.7267 54.3123 49.6646 54.9333 47.3469Z",
    fill: "#4C7D9F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9487 22.5635C34.9487 21.2064 36.0489 20.1063 37.406 20.1063V20.1063C38.7631 20.1063 39.8633 21.2064 39.8633 22.5635V24.5294C39.8633 25.8865 38.7631 26.9867 37.406 26.9867V26.9867C36.0489 26.9867 34.9487 25.8865 34.9487 24.5294V22.5635Z",
    fill: "#21272A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0542 22.5635C48.0542 21.2064 49.1544 20.1062 50.5115 20.1062V20.1062C51.8686 20.1062 52.9688 21.2064 52.9688 22.5635V24.5294C52.9688 25.8865 51.8686 26.9867 50.5115 26.9867V26.9867C49.1544 26.9867 48.0542 25.8865 48.0542 24.5294V22.5635Z",
    fill: "#21272A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8162 56.57C12.6766 59.781 11.2049 62.9652 8.52906 63.6822C5.85325 64.3992 2.98659 62.3774 2.12621 59.1664C1.26583 55.9554 2.73754 52.7712 5.41335 52.0542C8.08917 51.3372 10.9558 53.359 11.8162 56.57Z",
    fill: "#4C7D9F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5506 59.1676C86.411 55.9566 84.9393 52.7723 82.2634 52.0554C79.5876 51.3384 76.721 53.3602 75.8606 56.5711C75.0002 59.7821 76.4719 62.9664 79.1477 63.6833C81.8235 64.4003 84.6902 62.3785 85.5506 59.1676Z",
    fill: "#4C7D9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefaultState);
export default __webpack_public_path__ + "static/media/avatar_default_state.311fc9d6ea8b89a0b07671b06ae50e20.svg";
export { ForwardRef as ReactComponent };